import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router";
import { store } from "../components/Store";
import { SesionAPI } from "../services/api/Sesion";
import { CancelRequestController } from "../util/cancel-request-controller";
import { ClearStorage } from "../util/clear-storage";
import { usePersonalAccountInstitutionsManager } from "./use-user-institutions";

let abortController = new CancelRequestController();

const logoutRedirections = new Map();
logoutRedirections.set("Colsubsidio", { url: "https://www.colsubsidio.com/educacion/bibliotecas" });

/**
 * Hook personalizado para manejar el cierre de sesión.
 * @returns {{logout: Function, loading: boolean}} - Un objeto que contiene una función de cierre de sesión y el estado de carga.
 */
export const useLogout = () => {
	const [loading, setLoading] = useState(false);
	const history = useHistory();
	const { state, dispatch } = useContext(store);
	const isPersonalAccount = state?.isPersonalAccount;
	const institution = state?.datosHeader?.institucion;
	const institutionManager = usePersonalAccountInstitutionsManager();
	const currentPersonalAccountInstitution = institutionManager?.current?.name;

	const handleLogoutRedirections = () => {
		const url = logoutRedirections.get(institution).url;
		if (
			(!isPersonalAccount && logoutRedirections.has(institution)) ||
			(isPersonalAccount && logoutRedirections.has(currentPersonalAccountInstitution))
		) {
			window.location.replace(url);
		}else{
            history.push('/');
            window.location.reload();
        }
	};
	const logout = async () => {
		setLoading(true);
		await SesionAPI.cerrarSesion({ abortSignal: abortController.signal })
        .then(result => {
            dispatch({
                type: "CHANGE_VALUE",
                property: "sesionActiva",
                value: 'NO',
            });
            ClearStorage();
            handleLogoutRedirections();
		    })
		    .catch(err => console.log(err))
	};

	useEffect(() => {
		return () => {
			setLoading(false);
			abortController.abort();
			abortController = new CancelRequestController();
		};
	}, []);

	return {
		logout,
		loading,
	};
};
